/** @format */

import React, { useCallback } from 'react';
import {
	ModalContiner,
	ModalWrapperLarge,
	ModalWrapperSmall,
	BodyContainer,
	TitleWrapper,
	ContentWrapper,
	ButtonContainerLarge,
	ButtonContainerSmall,
	FooterWrapper,
	CloseButtonWrapper
} from './styles';
import Button, { types as buttonTypes } from 'components/V2/Button';
import Link from 'components/Link';
import useRWD from 'hooks/useRwd';
import { useModal } from 'modules/ui';

const Alert = ({
	background,
	image,
	title,
	content,
	buttons,
	footer,
	close,
	onClose
}) => {
	const { size, MD } = useRWD();
	const { boundToggleAlertModal } = useModal();
	const ModalWrapper = size >= MD ? ModalWrapperLarge : ModalWrapperSmall;
	const ButtonContainer =
		size >= MD ? ButtonContainerLarge : ButtonContainerSmall;

	const onClickClose = useCallback(() => {
		if (onClose) {
			onClose();
		}
		boundToggleAlertModal(false);
	});

	return (
		<ModalContiner>
			<ModalWrapper>
				<BodyContainer background={background}>
					<img src={image} />
					<TitleWrapper>{title}</TitleWrapper>
					<ContentWrapper>{content}</ContentWrapper>
					<ButtonContainer>
						{buttons.map((item) => {
							return (
								<Button color={item.color}>
									<Link path={item.url}>{item.text}</Link>
								</Button>
							);
						})}
					</ButtonContainer>
					<FooterWrapper>{footer}</FooterWrapper>
				</BodyContainer>
				<CloseButtonWrapper>
					<Button
						color={buttonTypes.supportOverlayLight}
						onClick={onClickClose}>
						{close}
					</Button>
				</CloseButtonWrapper>
			</ModalWrapper>
		</ModalContiner>
	);
};

export default React.memo(Alert);
